export default __webpack_public_path__ + "static/media/card_premio_reclame_aqui.4630068c.png";